$(() => {
  const publications = $(".publications-i")
  if (publications.length < 1) {
    return
  }

  const locale = $(".publications-filter--i_locale").data("locale")
  const publicationsOtherLocale = publications.not(`.publications-i_${locale}`)
  const publicationsAllCount = $(".publications-count--i_all")
  const publicationsActiveCount = $(".publications-count--i_active")

  $(".publications-filter--i").on("click", function clickHandler(event) {
    event.preventDefault()
    $(".publications-filter--i_active").removeClass(
      "publications-filter--i_active",
    )
    $(this).addClass("publications-filter--i_active")
    publicationsOtherLocale.toggle()
    publicationsAllCount.toggle()
    publicationsActiveCount.toggle()
  })
})
